(function () {
  var COOKIE_NAME = 'lf_modal_seen';
  var COOKIE_DAYS = 30;
  /* En mobile (92% del tráfico) se retrasa más para no interrumpir
     la primera exploración de productos; en desktop se deja igual. */
  var DELAY_MS = window.matchMedia('(max-width: 768px)').matches ? 12000 : 5000;

  /* ── Helpers de cookie ── */
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  var overlay      = document.getElementById('lf-modal-overlay');
  var form         = document.getElementById('lf-newsletter-form');
  var success      = document.getElementById('lf-modal-success');
  var closeBtn     = document.getElementById('lf-modal-close');
  var closeSuccess = document.getElementById('lf-modal-close-success');
  var copyCode     = document.getElementById('lf-copy-code');
  var copyHint     = document.getElementById('lf-copy-hint');
  var emailInput   = document.getElementById('lf-modal-email');
  var errorMsg     = document.getElementById('lf-modal-error');

  /* ── Detectar retorno de Shopify tras suscripción exitosa ── */
  var posted   = /[?&]customer_posted=true/.test(window.location.search);
  var hasError = !!errorMsg;

  function openModal() {
    overlay.classList.add('lf-modal-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    overlay.classList.remove('lf-modal-visible');
    document.body.style.overflow = '';
  }

  if (posted) {
    /* Suscripción confirmada por Shopify: mostrar éxito y sellar cookie */
    if (form) form.style.display = 'none';
    success.style.display = 'block';
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    openModal();
    /* Limpiar la URL para que un refresh no re-abra el modal */
    if (window.history && window.history.replaceState) {
      var clean = window.location.pathname + window.location.hash.replace(/#lf-newsletter-form/, '');
      window.history.replaceState(null, '', clean || window.location.pathname);
    }
  } else if (hasError) {
    /* Shopify devolvió error de formulario: reabrir para reintentar */
    openModal();
    if (emailInput) emailInput.focus();
  } else if (!getCookie(COOKIE_NAME)) {
    /* Flujo normal: abrir después del delay */
    setTimeout(openModal, DELAY_MS);
  } else {
    return;
  }

  /* ── Cerrar al hacer clic en el botón X ── */
  closeBtn.addEventListener('click', closeModal);

  /* ── Cerrar al hacer clic en el overlay (fuera del modal) ── */
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  /* ── Cerrar con Escape (solo si está visible) ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('lf-modal-visible')) {
      closeModal();
    }
  });

  /* ── Copiar código al hacer clic ── */
  copyCode.addEventListener('click', function () {
    var code = copyCode.textContent.trim();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(function () {
        copyHint.textContent = '¡Código copiado!';
        copyHint.style.color = '#2a6a2a';
        setTimeout(function () {
          copyHint.textContent = 'Haz clic en el código para copiarlo';
          copyHint.style.color = '#9B8470';
        }, 2500);
      });
    }
  });

  /* ── Botón "Cerrar e ir a la tienda" en estado éxito ── */
  closeSuccess.addEventListener('click', closeModal);

  /* ── Validación básica antes del submit real ── */
  if (form) {
    form.addEventListener('submit', function (e) {
      var email = emailInput.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        e.preventDefault();
        emailInput.style.borderColor = '#C8453A';
        emailInput.focus();
        return;
      }
      emailInput.style.borderColor = '';
      /* NO seteamos cookie aquí: solo cuando Shopify confirme
         (customer_posted=true) o cuando el usuario cierre el modal.
         El submit sigue su curso natural — si Shopify pide captcha,
         el usuario lo completa y vuelve con la confirmación. */
    });
  }

})();
